
function currencyFilter ($filter) {
	return function(input, decimals) {
		return $filter('number')(input, decimals) + ' €';
	};
}

currencyFilter.$inject = ['$filter'];

export default angular.module('filter.currencyFilter', [])
	.filter('currencyFilter', currencyFilter)
	.name;



// WEBPACK FOOTER //
// ./src/filter/currency.js